/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index radio to autogenerate all the components and extensions
 * Used by "prepareRadios"
 */

import Radio from './radio/Radio'
export * from './radio/Radio'
export default Radio
